import { useQuery } from '@tanstack/react-query';

import { FdmInstance } from '../../../types';

import { FdmClient } from './FdmClient';
import getLatestViewVersion from './getLatestViewVersion';
import { ViewReference } from './types';

export function useView(
  instance: FdmInstance,
  fdmClient: FdmClient
): {
  data: ViewReference | undefined;
  isLoading: boolean;
  isError: boolean;
  isFetching: boolean;
} {
  const { data, isLoading, isError, isFetching } = useQuery({
    queryKey: [
      'view',
      instance.viewSpace,
      instance.viewExternalId,
      instance.viewVersion,
    ],
    queryFn: async () => {
      const viewVersions = await fdmClient.getViewVersions(
        instance.viewSpace,
        instance.viewExternalId
      );
      const version =
        instance.viewVersion ?? getLatestViewVersion(viewVersions);

      return {
        space: instance.viewSpace,
        externalId: instance.viewExternalId,
        version: version,
      };
    },
  });

  return {
    data,
    isLoading,
    isError,
    isFetching,
  };
}
